"use strict";
/**
 * QVET API Response Types
 *
 * Item types and data payloads for QVET endpoints.
 *
 * ## Response Pattern
 *
 * Backend uses standard ApiResponse types from hvp-shared:
 * - Lists: `ApiListSuccessResponse<QvetSaleResponse[]>` with meta/links
 * - Single: `ApiSingleSuccessResponse<QvetSalesSummaryData>`
 * - Arrays (no pagination): `ApiSingleSuccessResponse<QvetSalesBySectionItem[]>`
 *
 * Frontend receives standard format:
 * ```json
 * {
 *   "ok": true,
 *   "status_code": 200,
 *   "resource": "qvet-sales",
 *   "operation": "all",
 *   "data": [...],
 *   "meta": { "total": 100, "page": 1, "limit": 25, "totalPages": 4, "itemsOnPage": 25 },
 *   "links": { "current": "...", "next": "...", ... }
 * }
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
